<template>
	<BaseModal
		:order="1"
		:title="typeof headline === 'function' ? title() : headline"
		ref="modal"
		@cancel="cancel"
		:modal-style="modalStyle"
		:hint="typeof hint === 'function' ? hint() : hint"
		class="text-right"
	>
		<component
			:is="component"
			v-if="!authNotAllowed"
			v-bind="$attrs"
			class="modalComponent"
			ref="component"
			@routeBack="routeBack"
			@scrollUp="scrollUp"
			@authNotAllowed="setNotAllowed(true)"
		/>
		<Forbidden v-else />
		<div class="inline flex justify-between">
			<BaseButton @click="routeBack" v-if="$store.getters.getModalHistory.length > 1">{{ $t('general.back') }}</BaseButton>
			<div v-else></div>
			<SaveButton v-if="saveButtonText" @click="$refs.component.save()">{{ saveButtonText }}</SaveButton>
		</div>
	</BaseModal>
</template>

<script>
import BaseModal from '@/components/modals/BaseModal';
import BaseButton from '@/components/forms/buttons/BaseButton';
import SaveButton from '@/components/forms/buttons/SaveButton';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'PageModal',
	components: { Forbidden, SaveButton, BaseButton, BaseModal },
	props: {
		title: {},
		component: { required: true },
		hint: {},
		saveButtonText: { type: String },
		modalStyle: { required: false },
		reAddConfirmLeaving: { default: false },
	},
	data() {
		return {
			authNotAllowed: false,
			headline: '',
		};
	},
	methods: {
		setNotAllowed(value) {
			this.authNotAllowed = value;
			this.headline = '';
		},
		scrollUp() {
			this.$refs.component.$el.scrollTo(0, 0);
		},
		cancel() {
			// push to parent route
			this.$router.replace({
				name: this.$route.matched[0].name,
				params: this.$route.params,
			});
			this.$store.dispatch('clearModalHistory').then(_ => {
				if (this.reAddConfirmLeaving) {
					this.$store.commit('setMuteConfirmLeaving', false);
				}
			});
		},
		routeBack() {
			const routeBefore = this.$store.getters.getBackRouteFromModalHistory;
			if (routeBefore) {
				this.$store.commit('popModalHistory');
				this.$store.commit('setConfirmLeaving', false);
				this.$router.replace(routeBefore);
			} else {
				this.cancel();
			}
		},
	},
	mounted() {
		this.headline = this.title;

		this.$refs.modal.show();
	},
	watch: {
		$route: {
			handler: function(search) {
				this.headline = this.title;
				this.$store.commit('addModalHistory', this.$route);
			},
			deep: true,
			immediate: true,
		},
	},
	beforeDestroy() {
		this.$store.dispatch('clearModalHistory');
	},
};
</script>

<style>
.modalComponent .main,
.modalComponent.main {
	max-height: 75vh;
	min-height: 30vh;
	@apply overflow-y-auto overflow-x-hidden;
}

@media only screen and (max-width: 1181px) {
	.modalComponent .main,
	.modalComponent.main {
		max-height: 80vh;
		min-height: 70vh;
	}
}
</style>
